export const PRODUCT_U_ID_LENGTH = 25;
export const RETURN_U_ID_LENGTH = 26;
